import type { OffersTranslation } from './types';

export const offersAr: OffersTranslation = {
  title: 'معروضة عليك',
  intro: 'اقبلها لتصبح المحادثة لك. إذا رفضتها أو انتهى الوقت، تُعرض على الشخص التالي.',
  timeLeft: 'بقي {{time}}',
  timeLeftLabel: 'الوقت المتبقي للقبول: {{time}}',
  timeUp: 'انتهى الوقت',
  round: 'العرض {{round}} من 3',
  accept: 'قبول',
  acceptName: 'قبول المحادثة مع {{name}}',
  decline: 'رفض',
  declineName: 'رفض المحادثة مع {{name}}',
  accepted: 'أصبحت المحادثة مع {{name}} لك.',
  declined: 'رفضت المحادثة مع {{name}}. ستُعرض على الشخص التالي.',
  closed: 'لم يعد هذا العرض متاحًا.',
  offeredTo: 'معروضة على {{name}} · {{time}}',
  offeredToYou: 'معروضة عليك · {{time}}',
  declineDialog: {
    title: 'رفض هذه المحادثة',
    description:
      'ستُعرض على الشخص التالي الذي يمكنه أخذها. يُحفظ سببك ليتمكن قائد فريقك من توزيع العمل.',
    reason: 'لماذا ترفضها؟',
    reasonMissing: 'اختر سببًا.',
    reasons: {
      at_capacity: 'لدي محادثات كثيرة الآن',
      not_my_area: 'هذا ليس من اختصاصي',
      going_offline: 'سأصبح غير متصل',
      other: 'سبب آخر',
    },
    goingOfflineHint: 'تصبح حالتك «بعيد»، فلا تُعرض عليك محادثات أخرى.',
    note: 'ملاحظة',
    noteHint: 'اختيارية. يمكن لقائد فريقك قراءتها.',
    submit: 'رفض المحادثة',
  },
  load: '{{open}} من {{max}} محادثات',
  loadNoLimit: '{{open}} محادثات مفتوحة',
  team: {
    summaryQueue: 'تنتظر المحادثات الجديدة في قائمة الفريق ليأخذها أي شخص.',
    summaryOffer: 'تُعرض المحادثات الجديدة على شخص واحد في كل مرة، {{seconds}} ثانية لكل شخص.',
    edit: 'كيف تصل المحادثات',
    editName: 'تغيير كيفية وصول المحادثات إلى {{team}}',
    title: 'كيف تصل المحادثات إلى {{team}}',
    description: 'اختر كيف تصل المحادثة المحوّلة إلى هذا الفريق إلى أفراده.',
    mode: 'عندما تصل محادثة إلى الفريق',
    modes: {
      queue: 'يراها الجميع',
      queueHint: 'تنتظر في قائمة الفريق ويأخذها أي شخص فيه.',
      offer: 'اعرضها على شخص واحد في كل مرة',
      offerHint:
        'تُعرض على أنسب شخص متصل: دون حده، ويتحدث لغة العميل، ولديه أقل عدد من المحادثات المفتوحة. إذا رفضها أو لم يرد في الوقت، تُعرض على الشخص التالي. بعد ثلاثة أشخاص تنتظر في القائمة. ويمكن لأي شخص أخذها في الأثناء.',
    },
    timeout: 'ثوانٍ للقبول',
    timeoutHint: 'من 15 إلى 600 ثانية.',
    timeoutInvalid: 'أدخل عدد ثوانٍ من 15 إلى 600.',
    save: 'حفظ',
    saved: 'حُفظت كيفية وصول المحادثات إلى {{team}}.',
  },
  people: {
    title: 'اللغات والحدود',
    description: 'تُعرض المحادثات أولًا على من يتحدثون لغة العميل، ولا تُعرض أبدًا على من بلغ حده.',
    none: 'لا لغات مدرجة',
    noLimit: 'بلا حد',
    limit: 'حتى {{max}} محادثات مفتوحة',
    edit: 'تعديل',
    editName: 'تعديل اللغات والحد لـ {{name}}',
    dialogTitle: 'اللغات والحد لـ {{name}}',
    languages: 'اللغات التي يجيب بها',
    max: 'أقصى عدد من المحادثات المفتوحة معًا',
    maxHint: 'من 1 إلى 50. اتركه فارغًا لعدم وضع حد.',
    maxInvalid: 'أدخل رقمًا من 1 إلى 50، أو اتركه فارغًا.',
    save: 'حفظ',
    saved: 'حُفظت اللغات والحد لـ {{name}}.',
    loading: 'جارٍ تحميل اللغات والحدود',
  },
};
